import React from 'react';

import { Consumer } from '../GenericComponents/HawkWidget/HawkWidgetProviderContext';
import { TargetEnum } from '../GenericComponents/TrackedLink/model';

import styles from './styles/seasonal-link-item.css';

interface SeasonalLinkItemProps {
  clickLink: () => void;
}

const SeasonalLinkItem: React.FC<SeasonalLinkItemProps> = ({ clickLink }) => (
  <Consumer>
    {(value): JSX.Element => {
      const {
        seasonalResponse,
        genericSharedComponents: { TrackedLink },
      } = value;

      if (!seasonalResponse.ok || !seasonalResponse.data.link) {
        return <></>;
      }

      return (
        <ul>
          <li>
            <TrackedLink
              trackLinkClick={clickLink}
              customTarget={TargetEnum.SELF}
              attributes={{
                href: seasonalResponse.data.link.url,
              }}
            >
              <span className={styles['link-text-color']}>
                {seasonalResponse.data.link.link_text}
              </span>
            </TrackedLink>
          </li>
        </ul>
      );
    }}
  </Consumer>
);

export default SeasonalLinkItem;
